import { render, staticRenderFns } from "./FourDots.vue?vue&type=template&id=66ac5580"
import script from "./FourDots.vue?vue&type=script&lang=js"
export * from "./FourDots.vue?vue&type=script&lang=js"
import style0 from "./FourDots.vue?vue&type=style&index=0&id=66ac5580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports